import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { Link } from "react-router-dom";
import NavIcon from "../../../icons/NavIcon";
import useStyles from "./styles";

function NavigationDrawerItem({ itemName, itemIcon, redirectLink, onClick }) {
  const classes = useStyles();
  return (
    <Link className={classes.link} to={redirectLink} onClick={onClick}>
      <ListItem button>
        <ListItemIcon className={classes.itemIcon}>
          {<NavIcon icon={itemIcon} />}
        </ListItemIcon>
        <ListItemText primary={itemName}/>
      </ListItem>
    </Link>
  );
}

export default NavigationDrawerItem;
